import { render, staticRenderFns } from "./CSSBlock.vue?vue&type=template&id=790201fc&"
import script from "./CSSBlock.vue?vue&type=script&lang=js&"
export * from "./CSSBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports